export function registerWebengageSubscribers() {
    // No subscriptions yet. Add eventBus.subscribe(...) calls here when a
    // real event is migrated to WebEngage through the bus.
}
